import { Injectable } from '@angular/core';
import {BaseApiService} from '../../common/base-api.service';
import {HttpClient} from '@angular/common/http';
import {SettingsProviderService} from '../../common/settings-provider.service';
import {Observable} from 'rxjs';
import {ICompanyDocument} from '../../message-models/company-document.interface';
import {ICompanyInfo} from '../../message-models/company-info.interface';
import {ICompanySearch} from '../../message-models/company-search.interface';
import { ICompanyAlertSettings } from '../../message-models/company-alert-settings.interface';
import { ICompanyAlertEmailSettings } from '../../message-models/company-alert-email-settings.interface';
import { CompanyAlertEmailSettings } from '../../message-models/company-alert-email-settings.class';
import { IAlertEmailOptions } from '../../message-models/alert-email-options.interface';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'Company');
  }
  getCompany(companyId: string): Observable<ICompanyInfo> {
    return this.post<ICompanyInfo>('GetCompany', { companyId });
  }

  updateCompany(company: ICompanyInfo): Observable<ICompanyInfo> {
    return this.post<ICompanyInfo>('UpdateCompany', company );
  }
  getCompaniesWith(companySearch: ICompanySearch): Observable<ICompanyInfo[]>{
    return this.post<ICompanyInfo[]>('SearchForCompanies', companySearch);
  }
  createOrUpdateCompanyAlertSettings(companyAlertSettings: ICompanyAlertSettings): Observable<ICompanyAlertSettings> {
    return this.post<ICompanyAlertSettings>('CreateOrUpdateCompanyAlertSettings', companyAlertSettings);
  }
  getCompanyAlertFrequencySettings(companyAlertSettings: ICompanyAlertSettings): Observable<ICompanyAlertSettings> {
    return this.post<ICompanyAlertSettings>('GetAlertFrequencySettings', companyAlertSettings);
  }
  getCompanyAlertEmailSettings(companyAlertSettings: ICompanyAlertSettings): Observable<ICompanyAlertEmailSettings[]> {
    return this.post<ICompanyAlertEmailSettings[]>('GetCompanyAlertEmailSettings', companyAlertSettings);
  }
  removeEmail(email: ICompanyAlertEmailSettings): Observable<ICompanyAlertEmailSettings> {
    return this.post<ICompanyAlertEmailSettings>('RemoveEmail', email);
  }
  getAlertEmailOptionsList(companyId: string): Observable<IAlertEmailOptions[]> {
    return this.post<IAlertEmailOptions[]>('GetAlertEmailOptions', { companyId })
  }
  addAlertEmail(emailAddRequest: ICompanyAlertEmailSettings[]): Observable<ICompanyAlertSettings> {
    return this.post<ICompanyAlertSettings>('AddAlertEmailSettings', emailAddRequest);
  }
}
